import { Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
const lockImg = 'https://wkemails.blob.core.windows.net/fe-application/lock.svg';


const workFlowToIconClassMap = {
    // [WorkflowTypeCode.CONCISE_CP]: 'p-[6px] h-[32px]'
}
const DashboardCardRound = ({ item, locked,className = '' }) => {
    // const { minDaysToexpiry } = useAppSelector((s) => s?.auth || null);

    const mainTitleIcon = null;
    const icon = item?.icon;
    const mainTitle = item?.name;
    const isLocked = item?.subscription?.includes('Lock') || locked
    const redirectUrl = false
    const derivedclassName = 'cursor-not-allowed'
    // const navigate = useNavigate()

    return (
        <button
            className={`gradient-border-button flex text-left bg-white flex-col w-max group gap-y-3.5 h-[56px] justify-center 
                items-center p-5 transition-all rounded-[32px] ${className} ${derivedclassName || ''
                }`}
            style={{
                boxShadow: "0px 6px 14px 0px rgba(42, 42, 74, 0.04)"
            }}
            key={`${mainTitleIcon}mainTitle`}
            id={'dashboard-card-' + item.code}
        >
            <div className={`flex justify-between items-center gap-2 w-full ${isLocked ? ' opacity-60 ' : ''}`}>
                <div className='flex items-center'>
                    <img src={icon} className={workFlowToIconClassMap[item.code] || 'h-[20px] w-[20px] mr-3 shrink-0'} />
                    <h5
                        key={`${2}_LayoutSubHead`}
                        className={'font-medium font-Inter-Regular text-[#343434] line-clamp-2 text-ellipsis'}
                    >
                        {mainTitle}
                    </h5>
                </div>
                <Tooltip title={item.description} className='font-Inter-Regular' arrow classes={{
                    tooltipArrow:
                        'dashboard-card-tooltip-arrow',
                    popper: 'dashboard-card-report-tooltip'
                }} >
                    <span className='group-hover:opacity-80 opacity-0'>
                        {isLocked ? <DashboardCardLockIcon /> : <IconInfoCircled />}
                    </span>
                </Tooltip>

            </div>

        </button>)
};

export default DashboardCardRound

const DashboardCardLockIcon = () => {
	return	<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.34375 11V7C8.34375 5.93913 8.76518 4.92172 9.51532 4.17157C10.2655 3.42143 11.2829 3 12.3438 3C13.4046 3 14.422 3.42143 15.1722 4.17157C15.9223 4.92172 16.3438 5.93913 16.3438 7V11M5.34375 13C5.34375 12.4696 5.55446 11.9609 5.92954 11.5858C6.30461 11.2107 6.81332 11 7.34375 11H17.3438C17.8742 11 18.3829 11.2107 18.758 11.5858C19.133 11.9609 19.3438 12.4696 19.3438 13V19C19.3438 19.5304 19.133 20.0391 18.758 20.4142C18.3829 20.7893 17.8742 21 17.3438 21H7.34375C6.81332 21 6.30461 20.7893 5.92954 20.4142C5.55446 20.0391 5.34375 19.5304 5.34375 19V13ZM11.3438 16C11.3438 16.2652 11.4491 16.5196 11.6366 16.7071C11.8242 16.8946 12.0785 17 12.3438 17C12.609 17 12.8633 16.8946 13.0509 16.7071C13.2384 16.5196 13.3438 16.2652 13.3438 16C13.3438 15.7348 13.2384 15.4804 13.0509 15.2929C12.8633 15.1054 12.609 15 12.3438 15C12.0785 15 11.8242 15.1054 11.6366 15.2929C11.4491 15.4804 11.3438 15.7348 11.3438 16Z" stroke="#202020" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
}

function IconInfoCircled() {
	return <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
		<path d="M9.75 8.97978C9.75 8.71456 9.85536 8.46021 10.0429 8.27267C10.2304 8.08514 10.4848 7.97978 10.75 7.97978C11.0152 7.97978 11.2696 8.08514 11.4571 8.27267C11.6446 8.46021 11.75 8.71456 11.75 8.97978V14.9798C11.75 15.245 11.6446 15.4994 11.4571 15.6869C11.2696 15.8744 11.0152 15.9798 10.75 15.9798C10.4848 15.9798 10.2304 15.8744 10.0429 15.6869C9.85536 15.4994 9.75 15.245 9.75 14.9798V8.97978ZM10.75 4.05078C10.4848 4.05078 10.2304 4.15614 10.0429 4.34367C9.85536 4.53121 9.75 4.78556 9.75 5.05078C9.75 5.316 9.85536 5.57035 10.0429 5.75789C10.2304 5.94542 10.4848 6.05078 10.75 6.05078C11.0152 6.05078 11.2696 5.94542 11.4571 5.75789C11.6446 5.57035 11.75 5.316 11.75 5.05078C11.75 4.78556 11.6446 4.53121 11.4571 4.34367C11.2696 4.15614 11.0152 4.05078 10.75 4.05078Z" fill="#3A3A3A" />
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.75 0C5.227 0 0.75 4.477 0.75 10C0.75 15.523 5.227 20 10.75 20C16.273 20 20.75 15.523 20.75 10C20.75 4.477 16.273 0 10.75 0ZM2.75 10C2.75 12.1217 3.59285 14.1566 5.09315 15.6569C6.59344 17.1571 8.62827 18 10.75 18C12.8717 18 14.9066 17.1571 16.4069 15.6569C17.9071 14.1566 18.75 12.1217 18.75 10C18.75 7.87827 17.9071 5.84344 16.4069 4.34315C14.9066 2.84285 12.8717 2 10.75 2C8.62827 2 6.59344 2.84285 5.09315 4.34315C3.59285 5.84344 2.75 7.87827 2.75 10Z" fill="#3A3A3A" />
	</svg>
}